<template>
	<section>
		<form id="submit_form" ref="submit_form" action>
			<div class="modal-card">
				<header class="modal-card-head">
					<p class="modal-card-title">{{ $t(modalData.modaltitle) }}</p>
					<button class="delete" type="button" @click="$parent.close()"></button>
				</header>
				<section class="modal-card-body">
					<b-field v-if="modalData.type == 'share'" label="Email" :message="$t('Recipient email address')">
						<b-input v-model="recipient" type="email" maxlength="50"></b-input>
					</b-field>
					<b-field :label="$t('Subject')" :message="$t('Subject of your message')">
						<b-input disabled v-model="subject" maxlength="90"></b-input>
					</b-field>
					<b-field :label="$t('Message')">
						<b-input v-model="message" maxlength="600" type="textarea"></b-input>
					</b-field>
				</section>
				<footer class="modal-card-foot sendmail-footer">
					<b-button expanded type="is-primary" @click="sendMail($event)">{{ $t('Send') }}</b-button>
				</footer>
			</div>
		</form>
	</section>
</template>

<script>
export default {
	data() {
		return {
			recipient: 'info@htaukcio.com',
			message: '',
			subject: this.product.name,
		}
	},
	props: {
		modalData: Object,
		product: Object,
	},
	methods: {
		sendMail(event) {
			// console.log(this.$refs.submit_form);
			var _this = this
			event.preventDefault()
			this.$http
				.post('email/' + _this.modalData.type, {
					product_id: _this.product.sku,
					product_name: _this.product.name,
					user_name: _this.$store.getters.bidder_name,
					user_email: _this.$store.getters.username,
					to: _this.recipient,
					subject: _this.$t(this.modalData.modaltitle) + ' - ' + _this.subject,
					text: _this.message,
					lang: localStorage.getItem('lang'),
				})
				.then(() => {
					this.$buefy.snackbar.open({
						message: _this.$t(this.modalData.sent),
						position: 'is-top',
						duration: 5000,
					})
					this.$parent.close()
				})
				.catch((error) => {
					alert(error)
				})
		},
	},
}
</script>
<style type="text/css"></style>
